import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 2.01875C9.16 2.01875 10.1 3.0175 10.1 4.25C10.1 5.4825 9.16 6.48125 8 6.48125C6.84 6.48125 5.9 5.4825 5.9 4.25C5.9 3.0175 6.84 2.01875 8 2.01875ZM8 11.5813C10.97 11.5813 14.1 13.1325 14.1 13.8125V14.9813H1.9V13.8125C1.9 13.1325 5.03 11.5813 8 11.5813ZM8 0C5.79 0 4 1.90188 4 4.25C4 6.59812 5.79 8.5 8 8.5C10.21 8.5 12 6.59812 12 4.25C12 1.90188 10.21 0 8 0ZM8 9.5625C5.33 9.5625 0 10.9863 0 13.8125V17H16V13.8125C16 10.9863 10.67 9.5625 8 9.5625Z",
		fill: "#09334B"
	})
});
export default SvgUser;
